export const SERVER_ENDPOINT = process.env.REACT_APP_SERVER_ENDPOINT;
export const BASE_API = `${SERVER_ENDPOINT}/api`;
export const SOCKET_ENDPOINT = process.env.REACT_APP_SOCKET_ENDPOINT || '';
export const ABOUT_PAGE_URL = process.env.REACT_APP_ABOUT_PAGE_URL || '';